import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import './AppliedFilters.css';
import {
  removeFilter,
  removeDateFilter,
  clearAllFilters,
  selectAppliedFilters,
  selectDateFilters,
  selectAvailableFilters
} from '../store/filterSlice';

function AppliedFilters() {
  const dispatch = useDispatch();
  const appliedFilters = useSelector(selectAppliedFilters);
  const dateFilters = useSelector(selectDateFilters);
  const availableFilters = useSelector(selectAvailableFilters);

  const getFilterDisplayName = (fieldName) => {
    const filter = availableFilters.find(f => f.key === fieldName);
    return filter?.def || fieldName;
  };

  const handleRemoveFilter = (fieldName, value) => {
    dispatch(removeFilter({ fieldName, value }));
  };

  const handleRemoveDateFilter = (fieldName) => {
    dispatch(removeDateFilter(fieldName));
  };

  const handleClearAll = () => {
    dispatch(clearAllFilters());
  };

  const hasFilters = Object.keys(appliedFilters).length > 0 || Object.keys(dateFilters).length > 0;

  if (!hasFilters) {
    return null;
  }

  return (
    <div className="applied-filters">
      <div className="applied-filters-header">
        <h4>Applied Filters</h4>
        <button className="clear-all-button" onClick={handleClearAll}>
          Clear All
        </button>
      </div>

      <div className="filter-tags">
        {/* Regular filters */}
        {Object.entries(appliedFilters).map(([fieldName, values]) =>
          values.map(value => (
            <div key={`${fieldName}-${value}`} className="filter-tag">
              <span className="filter-field">{getFilterDisplayName(fieldName)}:</span>
              <span className="filter-value">{value}</span>
              <button
                className="remove-filter-button"
                onClick={() => handleRemoveFilter(fieldName, value)}
                aria-label={`Remove ${value} from ${fieldName} filter`}
              >
                <svg width="12" height="12" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/>
                </svg>
              </button>
            </div>
          ))
        )}

        {/* Date filters */}
        {Object.entries(dateFilters).map(([fieldName, dateRange]) => (
          <div key={`date-${fieldName}`} className="filter-tag date-filter-tag">
            <span className="filter-field">{getFilterDisplayName(fieldName)}:</span>
            <span className="filter-value">
              {dateRange.startDate && dateRange.endDate
                ? `${dateRange.startDate} to ${dateRange.endDate}`
                : dateRange.startDate
                ? `From ${dateRange.startDate}`
                : `Until ${dateRange.endDate}`
              }
            </span>
            <button
              className="remove-filter-button"
              onClick={() => handleRemoveDateFilter(fieldName)}
              aria-label={`Remove date filter from ${fieldName}`}
            >
              <svg width="12" height="12" viewBox="0 0 24 24" fill="currentColor">
                <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/>
              </svg>
            </button>
          </div>
        ))}
      </div>
    </div>
  );
}

export default AppliedFilters;